import { Spin } from "antd";
import classNames from "classnames";

import { usesEffectiveCip20Ui } from "../../../util/betaFeatures";
import styles from "./styles.module.scss";

interface LoadingSkeletonProps {
  ariaLabel?: string;
  className?: string;
  compact?: boolean;
  rows?: number;
  variant?: "cards" | "lines" | "list";
}

const LoadingSkeleton = ({
  ariaLabel = "Loading content",
  className,
  compact = false,
  rows = 3,
  variant = "lines",
}: LoadingSkeletonProps) =>
  // Skeletons are part of the 2026 UI (beta: `cip2.0-ui` on user AND clinic,
  // never in Compassus mode). Shared legacy screens (e.g. Neo) keep their
  // original spinner for everyone else. Reads the beta-feature cache, so this
  // low-level component pulls in no store/router dependencies.
  !usesEffectiveCip20Ui() ? (
    <div
      className={classNames(
        styles.legacySpinner,
        { [styles.compact]: compact },
        className
      )}
      role="status"
      aria-label={ariaLabel}
    >
      <Spin size={compact ? "small" : "default"} />
    </div>
  ) : (
    <div
      className={classNames(
        styles.skeleton,
        styles[variant],
        { [styles.compact]: compact },
        className
      )}
      role="status"
      aria-label={ariaLabel}
    >
      {Array.from({ length: rows }, (_, index) => (
        <span className={styles.item} key={index}>
          {variant === "list" && <span className={styles.leading} />}
          <span className={styles.body}>
            <span />
            {variant !== "cards" && <span />}
          </span>
        </span>
      ))}
    </div>
  );

export default LoadingSkeleton;
